import React from 'react';
import PropTypes from 'prop-types';
import DataTable from './DataTable';
import QuickStats from './QuickStats';
import LoadingOverlay from '../LoadingOverlay';
import ResultsWrapper from './ResultsWrapper';
import { getVirtualShowroomTable, getTimeLabelFromMinutes } from './config';

function ResultsVirtualShowroom({ analytics, dealer }) {
  const { data } = analytics;

  const averageMinutes =
    data && data.totalAcceptedCount > 0
      ? Math.ceil(data.totalMinutesCount / data.totalAcceptedCount)
      : 0;

  return (
    <LoadingOverlay active={analytics?.fetching}>
      {data && (
        <div>
          <QuickStats
            stats={[
              {
                label: 'Total Connections Accepted',
                value: data.totalAcceptedCount,
              },
              {
                label: 'Total Connection Requests',
                value: data.totalRequestCount,
              },
              {
                label: 'Average Time Spent Connected',
                value: getTimeLabelFromMinutes(averageMinutes),
              },
              {
                label: 'Vehicles Sent To Customer',
                value: data.totalSuggestionCount,
              },
            ]}
          />
          <div className="row">
            <div className="col-xs-12">
              <DataTable
                data={data.userStatistics}
                config={getVirtualShowroomTable(dealer)}
              />
            </div>
          </div>
        </div>
      )}
    </LoadingOverlay>
  );
}

ResultsVirtualShowroom.propTypes = {
  analytics: PropTypes.object,
  dealer: PropTypes.object,
};

export default ResultsWrapper(ResultsVirtualShowroom);
